import getTimezoneOffsetFns from 'date-fns-tz/getTimezoneOffset';

export default function getTimezoneOffset(tz: string, date: Date): number {
  return getTimezoneOffsetFns(tz, date);
}
